import { Link } from 'react-router-dom';
import { profileInfo } from '@/mocks/profile';

export default function ProfileSummary() {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-6">
      <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-4 md:mb-5">个人资料</h3>
      <div className="flex flex-col items-center text-center">
        <div className="w-24 h-24 md:w-28 md:h-28 rounded-full overflow-hidden border-4 border-background-100 mb-4">
          <img src={profileInfo.avatar} alt={profileInfo.name} className="w-full h-full object-cover object-top" />
        </div>
        <p className="font-heading text-base md:text-lg font-bold text-foreground-950">{profileInfo.name}</p>
        <p className="text-xs text-foreground-500 mb-3">{profileInfo.englishName}</p>
        <ul className="text-sm text-foreground-700 space-y-1.5 w-full text-left mb-4">
          <li className="flex justify-between">
            <span className="text-foreground-500">生日</span>
            <span>{profileInfo.birthday}</span>
          </li>
          <li className="flex justify-between">
            <span className="text-foreground-500">出生地</span>
            <span>{profileInfo.birthplace}</span>
          </li>
          <li className="flex justify-between">
            <span className="text-foreground-500">职业</span>
            <span>{profileInfo.profession.join(' / ')}</span>
          </li>
        </ul>
        <Link
          to="/profile"
          className="cursor-pointer whitespace-nowrap w-full text-center bg-primary-700 hover:bg-primary-800 text-background-50 text-sm font-label py-2.5 rounded-md transition-colors"
        >
          查看完整资料
        </Link>
      </div>
    </div>
  );
}